import { Drawer } from './Drawer/Drawer';
import { Header } from './Header/Header';

export const UiAccountSelectionDrawer = {
  Drawer,
  Header,
};
